// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Dashboard_container__9wn8t {
        display: flex; 
        justify-content: center; 
        align-items: center;
        height: 90vh;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    .Dashboard_container__9wn8t {
        display: flex; 
        justify-content: center; 
        align-items: center;
        height: 90vh;
    }
}

/*MOBILE*/
@media screen and (max-width:767px){
    .Dashboard_container__9wn8t {
        display: flex; 
        justify-content: center; 
        align-items: center;
        height: 90vh;
    } 
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .container {\n        display: flex; \n        justify-content: center; \n        align-items: center;\n        height: 90vh;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    .container {\n        display: flex; \n        justify-content: center; \n        align-items: center;\n        height: 90vh;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    .container {\n        display: flex; \n        justify-content: center; \n        align-items: center;\n        height: 90vh;\n    } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dashboard_container__9wn8t`
};
export default ___CSS_LOADER_EXPORT___;
